import { typography } from '@dentalux/ui-library-core'
import { createUseStyles } from 'react-jss'
import { forPhoneOnly } from 'src/config/mediaQueries'
import customColors from 'src/config/colorsV2'

export default createUseStyles({
  linkButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    lineHeight: '19px',
    fontWeight: 500,
    color: customColors.primary,
    cursor: 'pointer',

    '&:active': {
      opacity: 0.5,
    },
  },
  linkText: {
    [forPhoneOnly]: {
      ...typography['Lato Emphasized 2'],
    },
  },
})
